/* @flow */

// Reducers needed for admin section (only used in "main" app)

import people from "platopulse/admin/people/people";
import databases from "platopulse/admin/databases/database";
import datamodel from "platopulse/admin/datamodel/datamodel";
import permissions from "platopulse/admin/permissions/permissions";
import settings from "platopulse/admin/settings/settings";

import { combineReducers } from "platopulse/lib/redux";

export default combineReducers({
    databases,
    datamodel,
    people,
    permissions,
    settings
})



// WEBPACK FOOTER //
// ./admin/admin.js